module.exports = __webpack_public_path__ + "static/media/27OCHA17.1b22b223.jpg";